import React, { createContext, useState, useContext, useEffect } from "react";

const SlugContext = createContext();

export const SlugProvider = ({ children }) => {
  const [slugs, setSlugs] = useState("");

  useEffect(() => {
    try {
      const storedSlugs = localStorage.getItem("slugs");
      // Handle all cases: undefined, null, or invalid JSON
      setSlugs(storedSlugs ? JSON.parse(storedSlugs) : "");
    } catch (err) {
      console.error("Failed to load slugs from localStorage:", err);
      setSlugs(""); // Fallback to default
      localStorage.removeItem("slugs"); // Clear corrupted data
    }
  }, []);

  // Optional: Auto-save when slugs change
  useEffect(() => {
    localStorage.setItem("slugs", JSON.stringify(slugs));
  }, [slugs]);

  return (
    <SlugContext.Provider value={{ slugs, setSlugs }}>
      {children}
    </SlugContext.Provider>
  );
};

export const useSlug = () => useContext(SlugContext);
